"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areVideoPreferencesEqual = areVideoPreferencesEqual;
exports.buildVideoPreferences = void 0;
exports.getCameraAndScreenShareSourcesInProgram = getCameraAndScreenShareSourcesInProgram;
var _constants = require("@studio/constants");
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function getCameraAndScreenShareSourcesInProgram(program) {
  return program === null || program === void 0 ? void 0 : program.layers.filter(function (programLayer) {
    var _programLayer$source, _programLayer$source2;
    return [_constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes((_programLayer$source = programLayer.source) === null || _programLayer$source === void 0 ? void 0 : _programLayer$source.type) && ((_programLayer$source2 = programLayer.source) === null || _programLayer$source2 === void 0 ? void 0 : _programLayer$source2.value) !== _constants.UNASSIGNED;
  }).map(function (item) {
    return item.source.value;
  });
}

/**
 * Compares two sets of video preferences to determine if they are equal. Used so be don't
 * update the video preferences if they haven't changed.
 */
function areVideoPreferencesEqual(prevPreferences, newPreferences) {
  if (!prevPreferences || !newPreferences) {
    return false;
  }
  var prevMap = new Map();
  var _iterator = _createForOfIteratorHelper(prevPreferences),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pref = _step.value;
      if (pref && pref.attendeeId !== undefined && pref.priority !== undefined) {
        prevMap.set(pref.attendeeId, pref.priority);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(newPreferences),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _pref = _step2.value;
      if (prevMap.get(_pref.attendeeId) !== _pref.priority) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return prevPreferences.length === newPreferences.length;
}

/**
 * Builds video preferences based on sources in and not in the program.
 * @param {Array} inProgramSources - Sources in the program.
 * @param {Array} notInProgramSources - Sources not in the program.
 * @returns {Array} - Built video preferences.
 */
var buildVideoPreferences = exports.buildVideoPreferences = function buildVideoPreferences(inProgramSources, notInProgramSources) {
  var videoPreferences = _amazonChimeSdkJs.VideoPreferences.prepare();

  /**
   * This is to avoid very low resolutions (like 136p) when there are 3 or 4 cameras on.
   * With 3 or 4 cameras on, senders will be sending 540p as per default uplink policy
   * and quite possibly 3 SVC layers. If we choose LOW, we'll be receiving the lowest layer (e.g. 136p)
   * but as soon as no. of cameras go to 5, expected resolution changes to 480p and senders will be sending only 2 layers
   * In that case, LOW changes to something like 240p.
   * So even though the no. of camera have increased, there is an increase in resolution which is counter-intuitive and confusing
   * Also, 136p looks terrible in presenter gallery view
   * To mitigate this, we'll request MEDIUM until 5 sources (might include screenshare)
   * and after that, it'll be LOW to keep resolutions consistent
   */
  var targetDisplaySizeForOffStageAttendees = _amazonChimeSdkJs.TargetDisplaySize.Low;
  var totalSourcesInSession = inProgramSources.length + notInProgramSources.length;
  if (totalSourcesInSession <= 5) {
    targetDisplaySizeForOffStageAttendees = _amazonChimeSdkJs.TargetDisplaySize.Medium;
  }
  inProgramSources.forEach(function (value) {
    videoPreferences.add(new _amazonChimeSdkJs.VideoPreference(value, 1, _amazonChimeSdkJs.TargetDisplaySize.High));
  });
  notInProgramSources.forEach(function (value) {
    videoPreferences.add(new _amazonChimeSdkJs.VideoPreference(value, 2, targetDisplaySizeForOffStageAttendees));
  });
  return videoPreferences.build();
};